function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { product_queryPage, getExcelPath, download, agentClaim_import, saveProduct, deleteProduct, saveEditProduct as _saveEditProduct } from '@/api/baseDataManage';
import { getCompanyList } from '@/api/baseDate';
export default {
  name: 'productConfiguration',
  data: function data() {
    return {
      flagOptions: [{
        value: '1',
        label: '进口'
      }, {
        value: '2',
        label: '出口'
      }, {
        value: '3',
        label: '内陆'
      }],
      areas: [],
      countrys: [],
      citys: [],
      countryList: [],
      cityList: [],
      cityArr: [],
      fileList: [],
      company: '',
      // 保险公司
      companyList: [],
      // 获取保险公司列表并匹配
      // 查询条件
      form: {
        riskCode: '',
        riskName: '',
        ieFlag: '',
        pageNo: 1,
        pageSize: 10
      },
      productId: '',
      total: 0,
      // 数据条数
      // 列表数据
      tableData: [],
      loading: false,
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      editData: {},
      markForm: {
        productId: '',
        riskCode: '',
        riskName: '',
        ieFlag: '',
        type: ''
      },
      markForm_new: {
        productId: '',
        riskCode: '',
        riskName: '',
        ieFlag: '',
        type: ''
      },
      countryrule: {
        riskCode: [{
          required: true,
          message: '请输入产品代码',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]+$/,
          message: '产品代码必须录入字母或数字'
        }],
        ieFlag: [{
          required: true,
          message: '请输入进出口',
          trigger: 'blur'
        }],
        riskName: [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    getCompanyList().then(function (res) {
      _this.companyList = Object.assign([], res);
      _this.company = _this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));

      _this.getData();
    });
  },
  methods: {
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;
      this.getData();
    },
    // 获取数据
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      product_queryPage(_objectSpread({}, this.form)).then(function (res) {
        _this2.loading = false;
        _this2.total = res.totalCount;
        _this2.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.form.riskCode = '';
      this.form.riskName = '';
      this.form.ieFlag = '';
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    // 编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this3 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new;

      if (type == 'edit') {
        this.markForm.type = '1';
      } else {
        this.markForm_new.type = '0';
      }

      this.$refs[formName].validate(function (valid) {
        // this.new_edit = this.newumarBtn = false
        if (valid) {
          _this3.openFullScreen();

          saveProduct(data).then(function (res) {
            _this3.screenLoading.close();

            if (res.resultCode == '0000') {
              _this3.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this3.markForm_new) {
                _this3.markForm_new[key] = '';
              }

              _this3.newumarBtn = false;
              _this3.new_edit = false;

              _this3.getData();
            } else {
              _this3.$message({
                message: res.resultMsg,
                type: 'warning'
              });
            }

            _this3.markForm_new = {
              riskCode: '',
              riskName: '',
              ieFlag: '',
              productId: '',
              type: ''
            };
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑保存
    saveEditProduct: function saveEditProduct(formName, type) {
      var _this4 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new;

      if (type == 'edit') {
        this.markForm.type = '1';
      } else {
        this.markForm_new.type = '0';
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.openFullScreen();

          _saveEditProduct(data).then(function (res) {
            _this4.screenLoading.close();

            if (res.resultCode == '0000') {
              _this4.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this4.markForm_new) {
                _this4.markForm_new[key] = '';
              }

              _this4.newumarBtn = false;
              _this4.new_edit = false;

              _this4.getData();
            } else {
              _this4.$message({
                message: res.resultMsg,
                type: 'warning'
              });
            }

            _this4.markForm_new = {
              riskCode: '',
              riskName: '',
              ieFlag: '',
              productId: '',
              type: ''
            };
          });
        } else {
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      this.new_edit = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      }
    },
    // 删除
    dele: function dele(data) {
      var _this5 = this;

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteProduct({
          productId: data.productId
        }).then(function (res) {
          if (res.resultCode == '0000') {
            _this5.$message({
              type: 'success',
              message: '删除成功!'
            });

            _this5.submitForm();
          } else {
            _this5.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this6 = this;

      console.log('formname', formname);

      if (type == 'new') {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.getData();
      this.$nextTick(function () {
        _this6.$refs[formname].clearValidate();
      });
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: 'claim'
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          // 获取下载文件
          download({
            fileSrc: res.fileSrc + '理赔代理点导入模板.xlsx'
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: 'application/vnd.ms-excel'
            }); // 兼容ie

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, '理赔代理点清单模板.xlsx');
            } else {
              var url = window.URL.createObjectURL(blob);
              var link = document.createElement('a'); // 创建a标签

              link.href = url;
              link.download = '理赔代理点清单模板.xlsx'; // 重命名文件

              link.click();
              window.URL.revokeObjectURL(url); // 释放内存
            }
          });
        }
      });
    },
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this7 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);

      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
        return;
      }

      var dataFile = new FormData();
      dataFile.append('file', file.file);
      this.openFullScreen2();
      agentClaim_import(dataFile).then(function (res) {
        _this7.screenLoading.close();

        if (res.resultCode == '0000') {
          _this7.$message({
            type: 'success',
            message: '导入成功'
          });

          _this7.getData();
        } else {
          _this7.$message({
            type: 'warning',
            message: res.resultMsg
          });
        }
      });
    }
  }
};